export default __webpack_public_path__ + "static/media/Image2.81ef4a05.jpg";